import React from "react";
import { Info } from "lucide-react";

const Dashboard = () => {
    const user = localStorage.getItem("username");

    return (
        <div className="min-h-screen bg-gray-100 px-3 sm:px-4 md:px-6 py-6">
            <div className="w-full max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-5 sm:mb-7">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 text-center">
                        Dashboard
                    </h1>
                    <div className="mt-3 h-px w-full bg-slate-200" />
                </div>

                {user && (
                    <div className="flex flex-col gap-4 w-full max-w-7xl mx-auto">
                        {/* Notice */}
                        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                            <div className="px-5 py-5 sm:px-6 sm:py-6">
                                <div className="flex items-start gap-4">
                                    <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-900 text-white">
                                        <Info className="h-5 w-5" aria-hidden="true" />
                                    </div>

                                    <div className="min-w-0 text-left">
                                        <h2 className="text-lg sm:text-xl font-bold text-slate-900">
                                            Notice
                                        </h2>
                                        <p className="mt-2 text-sm sm:text-base leading-relaxed text-slate-700 text-left">
                                            If you have any questions, please contact{" "}
                                            <a
                                                href="mailto:technology@ciilock.com"
                                                className="font-semibold text-slate-900 underline decoration-slate-300 underline-offset-4 hover:decoration-slate-500 break-all"
                                            >
                                                technology@ciilock.com
                                            </a>
                                            .
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Introduction */}
                        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                            <div className="px-5 py-5 sm:px-6 sm:py-6 text-left space-y-3 text-sm sm:text-base leading-relaxed text-slate-700">
                                <h2 className="text-lg sm:text-xl font-bold text-slate-900">
                                    Introduction
                                </h2>
                                <p>
                                    Use the Glass Finder per company workflow to upload a manufacturer
                                    PDF, extract the window systems, and resolve each row against that
                                    single producer&apos;s catalog. It keeps the scope tight so every
                                    match comes from the same accredited company report.
                                </p>
                                <p>
                                    When you need a broader view, the PDF Glass Finder lets you scan
                                    any report, filter by material or performance metrics, and compare
                                    multiple manufacturers with targeted U/SHGC/Tvis ranges.
                                </p>
                            </div>
                        </div>

                        {/* Function */}
                        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                            <div className="px-5 py-5 sm:px-6 sm:py-6 text-left text-sm sm:text-base leading-relaxed text-slate-700 space-y-3">
                                <h2 className="text-lg sm:text-xl font-bold text-slate-900">
                                    Function
                                </h2>
                                <p>
                                    The company PDF tool performs a focused scan, resolves only the
                                    registered windows within that manufacturer, and lets you export
                                    clean tables for downstream review or registration requests.
                                </p>
                                <p>
                                    The general PDF Glass Finder adds automatic filtering, sorting,
                                    and manual refinement so you can isolate eligible manufacturers,
                                    inspect required product types, and surface matching glass
                                    without leaving the dashboard.
                                </p>
                                <p>
                                    Both flows support substance-sensitive reporting (U, SHGC, Tvis)
                                    and hand off to the Glass Finder export/registration prompts
                                    whenever a system needs sales approval.
                                </p>
                            </div>
                        </div>

                        {/* Subscription */}
                        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                            <div className="px-5 py-5 sm:px-6 sm:py-6 text-left text-sm sm:text-base leading-relaxed text-slate-700">
                                <h2 className="text-lg sm:text-xl font-bold text-slate-900">
                                    Subscription
                                </h2>
                                <p>
                                    Want ongoing access to these capabilities or to onboard a team?
                                    Contact{" "}
                                    <a
                                        href="mailto:sales@ciilock.com"
                                        className="font-semibold text-slate-900 underline decoration-slate-300 underline-offset-4 hover:decoration-slate-500"
                                    >
                                        sales@ciilock.com
                                    </a>{" "}
                                    and we&apos;ll walk you through the subscription paths and
                                    enterprise options.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;
